export default __webpack_public_path__ + "static/media/13.b21b3733.png";